//frontend/utils/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { iniciarTema } from './componentes/base/tema';

// Antes de pintar: si se aplicara dentro de un componente, la primera
// pasada saldría en claro y se vería un destello blanco al abrir la app
// con el tema oscuro puesto.
iniciarTema();

/* ==============================
   DEBUG GLOBAL (Safari / iOS)
============================== */
window.addEventListener("error", (e) => {
  console.log("[window.error]", e?.message, e?.filename, e?.lineno, e?.colno, e?.error);
});

window.addEventListener("unhandledrejection", (e) => {
  console.log("[unhandledrejection]", e?.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
